module.exports = ":host /deep/ md-divider {\n  display: block;\n  border-top-style: solid;\n  border-top-width: 1px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/login/login.component.scss
// module id = ./src/app/login/login.component.scss
// module chunks = main